export const messages = {
    'zh_CN': {
        i18n: {
            system_name:'上海合亿FOTA管理平台',
            no_data:'暂无数据',
            home:'首页',

           //left menu
            fota_update:'FOTA升级',
            project_mange:'项目管理',
            version_mange:'版本管理',
            version_history:'历史版本',
            version_add:'添加版本',
            version_update:'编辑版本',
            gray_test:'灰度测试',
            imei_mange:'IMEI管理',
            apk_update:'APP升级',
            apk_mange:'APP管理',
            apk_version:'APP版本',

       
            
            //列字段、输入框、label
            column:{
                username:'用户名',
                password:'密码',
                validatecode:'验证码',
                
                //时间相关
                update_time:'更新时间',
                create_time:'创建时间',
                release_time:'发布日期',
                start_time:'开始时间',
                end_time:'结束时间',

                //项目先关
                operator:'操作',
                project:'项目名',
                project_name:'项目名称',
                design:'设计公司',
                brand:'品牌商',
                oem:'OEM',
                product_name:'产品名称',
                language:'语言',

                //版本相关
                system_version:'系统版本号',
                memo:'备注',
                version_id:'版本ID',
                versionNo:'版本号',
                source_versionNo:'源版本号',
                versionNo_update:'升级版本号',
                description:'版本描述',
                upload_ota_package:'上传OTA包',
       

                //定制策略
                update_strategy:'升级策略',
                version_custom_strategy:'版本定制策略',
                current_versionNo:'当前版本号',
                target_versionNo:'目标版本号',
                update_package_name:'升级包名称',
                update_package_size:'升级包大小',
                new_version_tip:'新版本提示',
                no_tip:'无提示',
                dialog:'对话框',
                notice_board:'通知栏',
                install_tip:'安装提示',
                auto_download:'自动下载',
                base_client:'以客户端为准',
                yes_only_wifi:'是-仅wifi',
                yes_any_network:'是-任意网络',
                auto_install:'自动安装',
                install_time_period:'安装时间段',
                update_success_tip:'升级成功提示',
                update_battery_level :'升级电量要求',
                is_update_only_imei :'是否按IMEI升级',
                yes_white_list :'是-白名单',
                yes_black_list :'是-黑名单',
                is_black_list :'是否黑名单',
                white_list :'白名单',
                black_list :'黑名单',
                import_or_query_imei :'导入或查看IMEI',
                please_input_content :'请输入内容',

                
                //状态相关
                publish_status:'发布状态',
                publish_status1:'内测中',
                publish_status2:'已发布',
                publish_status3:'已停用',
                version_status:'版本状态',
                is_enabled:'是否启用',
                current_status:'当前状态',
                init_version:'初始版本',
                published:'已发布',
                wait_test:'待测试',
                wait_upload:'待上传',
                wait_publish:'待发布',
                publish:'发布',
                test_pass:'测试通过',
                test_not_pass:'测试不通过',
                cancel_publish:'取消发布',


                //文件相关
                file_upload:'文件上传',
                file_size:'文件大小',
                file_name:'文件名',
                file_md5:'文件MD5',
                download_url:'下载地址',
                download:'下载',
                upload_update_file:'上传升级包',
                file_sync_status:'文件同步状态',

                //搜索相关
                imei_search:'IMEI搜索',
                version_search:'版本搜索',
                project_search:'项目名搜索',
                like_search:'模糊搜索',
                name_search:'名称搜索',
                unicode_search:'唯一码搜索',

                //app相关
                app_name:'APP名称',
                app_code:'APP唯一码',
                app_code_placeholder:'APP包名，如com.unione.fota.mtk',
                app_desc:'简介',
                upload_install_package:'上传安装包',
          
            },
            span:{
                'apk_uploading':'您正在上传{apkName}的APK文件，当前版本{versionNo}',
                'fota_uploading':'您正在上传{projectName}项目的文件，从版本{currentVersionNo} 升级到{updateVersionNo}',

            },
            validate:{
                upload_file_need:'请上传文件',
                versionNo_need:'请输入版本号',
                versionNo_sizie_need:'请输入版本大小',
                release_time_need:'请输入发布日期',
                design_need:'请选择设计公司',
                brand_need:'请选择品牌商',
                project_need:'请选择项目',
                product_name_need:'请输入产品名称',
                oem_need:'请输入OEM',
                iemi_need:'请输入IMEI',
                language_need:'请输入语言',
                operator_need:'请输入OPERATOR',
                imei_need:'IMEI必填',
                username_need:'请输入用户名',
                password_need:'请输入密码',
                validate_code_need:'请输入验证码',
                validate_code_error:'验证码错误',
                file_upload_need:'请上传文件',
                white_black_list_need:'请选择黑白名单',
                app_name_need:'请输入APP名称',
                app_package_name_need:'请输入APP包名',
                app_desc_need:'请输入APP描述',
                app_need:'请选择APP',
                description_need:'请输入版本描述',
                
            },
            //登录退出
            login: '登录',
            login_out:'退出登录',
            
            //通用按钮
            yes:'是',
            no:'否',
            cancel:'取消',
            confirm:'确定',
            commit:'提交',
            delete:'删除',
            update:'编辑',
            reset:'重置',
            settings:'设置',
            upload:'上传',
            download:'下载',
            custom_config:'定制配置',

            //项目相关
            project_add:'添加项目',

             //系统版本相关
             add_version:'添加',

            //选择xx
            choose_language:'选择语言',
            choose_file:'选择文件',
            choose_project:'选择项目',
            choose_design:'选择设计公司',
            choose_brand:'选择品牌商',
            choose_type:'选择类型',
            choose_app:'选择App',

            //上传文件
            upload_start:'开始上传',
            upload_pause:'暂停上传',
            upload_ok:'上传成功',
            upload_fail:'上传失败',
            loading_data:'正在加载数据',
            loading_ok_upload:'加载完成，请开始上传',

            // imei相关
            batch_import_imei:'批量导入IMEI',
            add_imei:'添加IMEI',
            delete_imei_by_project:'删除指定项目IMEI',
            imei_add_tip:'IMEI号,多个用英文逗号分隔',
            mcu_white_imei :'新增IMEI白名单',
            batch_import_excel:'Excel表格批量导入',
            download_excel_template:'Excel模板下载',

            //app相关
            app_add:'新增APP',
            app_update:'编辑APP',
            app_version_query:'查看版本',
            app_version_add:'新增版本',
      
            //弹框相关
            tip:'提示',
            is_delete_continue:'此操作将永久删除该数据, 是否继续?',
            is_commit_data:'是否提交数据?',
            had_cancel_delete:'已经取消删除！',
            had_cancel_commit:'已经取消提交！',
            success:'操作成功',
            fail:'操作失败',


            to_last_step:'返回上一页'

        }
    },
    'en_US': {
          i18n: {
            system_name:'Shanghai Unione FOTA Manage System',
            no_data:'No data',
            home:'Home',

           //left menu
            fota_update:'FOTA Update',
            project_mange:'ProjectManage',
            version_mange:'VersionManage',
            version_history:'HistoryVersion',
            version_add:'AddVersion',
            version_update:'UpdateVersion',
            gray_test:'GrayTest',
            imei_mange:'IMEIManage',
            apk_update:'AppUpdate',
            apk_mange:'AppManage',
            apk_version:'APPVersion',

       
            
            //列字段、输入框、label
            column:{
                username:'UserName',
                password:'Password',
                validatecode:'ValidateCode',
                
                //时间相关
                update_time:'UpdateTime',
                create_time:'CreateTime',
                release_time:'ReleaseTime',
                start_time:'StartTime',
                end_time:'EndTime',

                //项目先关
                operator:'Operator',
                project:'ProjectName',
                project_name:'ProjectName',
                design:'Designer',
                brand:'Brand',
                oem:'OEM',
                product_name:'ProductName',
                language:'Language',

                //版本相关
                system_version:'SystemVersion',
                memo:'Memo',
                version_id:'VersionID',
                versionNo:'VersionNo',
                source_versionNo:'SourceVersionNo',
                versionNo_update:'ToVersionNo',
                description:'Description',
                upload_ota_package:'UploadOTAFile',
       

                //定制策略
                update_strategy:'UpgradeStrategy',
                version_custom_strategy:'CustomStrategy',
                current_versionNo:'CurrentVersionNo',
                target_versionNo:'TargetVersionNo',
                update_package_name:'FileName',
                update_package_size:'FileSize',
                new_version_tip:'NewVersionTip',
                no_tip:'NoTip',
                dialog:'Dialog',
                notice_board:'NoticeBoard',
                install_tip:'InstallTip',
                auto_download:'AutoDownload',
                base_client:'BaseClient',
                yes_only_wifi:'Yes-OnlyWifi',
                yes_any_network:'Yes-AnyNetwork',
                auto_install:'AutoInstall',
                install_time_period:'InstallTimePeriod',
                update_success_tip:'UpdateSuccessTip',
                update_battery_level :'UpdateBatteryLevel',
                is_update_only_imei :'IsUpdateOnlyIMEI',
                yes_white_list :'Yes-WhiteList',
                yes_black_list :'Yes-BlackList',
                is_black_list :'IsBlackList',
                white_list :'WhiteList',
                black_list :'BlackList',
                import_or_query_imei :'ImportOrQueryIMEI',
                please_input_content :'InputContent',

                
                //状态相关
                publish_status:'publishStatus',
                publish_status1:'Testing',
                publish_status2:'Published',
                publish_status3:'Stopped',
                version_status:'VersionStatus',
                is_enabled:'IsEnabled',
                current_status:'CurrentStatus',
                init_version:'InitVersion',
                published:'Published',
                wait_test:'WaitTest',
                wait_upload:'WaitUpload',
                wait_publish:'WaitPublish',
                publish:'Publish',
                test_pass:'TestPass',
                test_not_pass:'TestFailed',
                cancel_publish:'CancelPublish',


                //文件相关
                file_upload:'UploadFile',
                file_size:'FileSize',
                file_name:'FileName',
                file_md5:'FileMd5',
                download_url:'DownloadUrl',
                download:'Download',
                upload_update_file:'UploadFile',
                file_sync_status:'FileSyncStatus',

                //搜索相关
                imei_search:'IMEISearch',
                version_search:'VersionSearch',
                project_search:'ProjectSearch',
                like_search:'Search',
                name_search:'NameSearch',
                unicode_search:'UnicodeSearch',

                //app相关
                app_name:'APPName',
                app_code:'APPCode',
                app_code_placeholder:'APP package name，like com.unione.fota.mtk',
                app_desc:'AppDescription',
                upload_install_package:'UploadInstallFile',
          
            },
            span:{
                'apk_uploading':'You are uploading {apkName} apk file，current {versionNo}',
                'fota_uploading':'You are uploading {projectName} project file，from {currentVersionNo} to {updateVersionNo}',

            },
            validate:{
                upload_file_need:'please upload file',
                versionNo_need:'please input version number',
                versionNo_sizie_need:'please input file size',
                release_time_need:'please choose release date',
                design_need:'please choose design company',
                brand_need:'please choose brand company',
                project_need:'please choose project',
                product_name_need:'please input product name',
                oem_need:'please input oem',
                iemi_need:'please input IMEI',
                language_need:'please input language',
                operator_need:'please input operator',
                imei_need:'IMEI not empty',
                username_need:'please input username',
                password_need:'please input password',
                validate_code_need:'please input validate code',
                validate_code_error:'validate code error',
                file_upload_need:'please upload file',
                white_black_list_need:'please choose white or black list',
                app_name_need:'please input app name',
                app_package_name_need:'please input app package',
                app_desc_need:'please input app description',
                app_need:'please choose app',
                description_need:'please input version description',
                
            },
            //登录退出
            login: 'Login',
            login_out:'LoginOut',
            
            //通用按钮
            yes:'Yes',
            no:'No',
            cancel:'Cancel',
            confirm:'Confirm',
            commit:'Commit',
            delete:'Delete',
            update:'Update',
            reset:'Reset',
            settings:'Settings',
            upload:'Upload',
            download:'Download',
            custom_config:'CustomConfig',

            //项目相关
            project_add:'AddProject',

             //系统版本相关
             add_version:'AddVersion',

            //选择xx
            choose_language:'ChooseLanguage',
            choose_file:'ChooseFile',
            choose_project:'ChooseProject',
            choose_design:'ChooseDesigner',
            choose_brand:'ChooseBrand',
            choose_type:'ChooseType',
            choose_app:'ChooseApp',

            //上传文件
            upload_start:'StartUpload',
            upload_pause:'PauseUpload',
            upload_ok:'UploadOk',
            upload_fail:'UploadFail',
            loading_data:'LoadingData',
            loading_ok_upload:'LoadingOk,please upload',

            // imei相关
            batch_import_imei:'BatchImportIMEI',
            add_imei:'AddIMEI',
            delete_imei_by_project:'DeleteIMEIByProject',
            imei_add_tip:'IMEI number, multiple separated by commas in English',
            mcu_white_imei :'AddIMEIWhiteList',
            batch_import_excel:'BatchImportByExcel',
            download_excel_template:'DownloadExcelTemplate',

            //app相关
            app_add:'AddApp',
            app_update:'UpdateApp',
            app_version_query:'QueryVersion',
            app_version_add:'AddVersion',
      
            //弹框相关
            tip:'Tip',
            is_delete_continue:'This operation will permanently delete the data. Do you want to continue?',
            is_commit_data:'Do you want to submit data?',
            had_cancel_delete:'The deletion has been cancelled！',
            had_cancel_commit:'Submission has been cancelled！',
            success:'operation successful',
            fail:'operation fail',

            
            to_last_step:'ToLastStep'

        }
    }
}